import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { AuthService } from '../services/auth-service/auth.service';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AuthComponent implements OnInit, OnDestroy {
  public isAuthenticating: boolean;
  private onDestroy$: Subject<void>;

  constructor(private authService: AuthService, private router: Router) {
    this.isAuthenticating = true;
    this.onDestroy$ = new Subject<void>();
  }

  public ngOnInit(): void {
    // authentication completed successfully, redirect to payment landing page
    this.authService.onTokenReceived.pipe(takeUntil(this.onDestroy$)).subscribe(() => {
      const target = sessionStorage.getItem('post_login_redirect_uri') ?? '/';
      sessionStorage.removeItem('post_login_redirect_uri');
      void this.router.navigateByUrl(target, { replaceUrl: true });
    });

    // authentication failed, display error message
    this.authService.onError.pipe(takeUntil(this.onDestroy$)).subscribe(() => (this.isAuthenticating = false));
  }

  public ngOnDestroy(): void {
    // component is destroyed, emit to close open subscriptions
    this.onDestroy$.next();
  }
}
